import React from 'react';
import { useNavigate } from 'react-router-dom';
import './AboutUs.css'; // Import CSS for styling

const AboutUs = () => {
  const navigate = useNavigate(); // Hook for navigation

  return (
    <div className="about-us-container">
      <div className="about-us-hero">
        <h1 className="about-us-title">About Us</h1>
      </div>

      <section className="about-us-section">
        <h2>Mission Statement</h2>
        <p>
          To glorify God by providing community for members, providing others with sexual abstinence education, providing mentorship for seeking individuals, and emphasizing the importance of marriage and holistic health.
        </p>
      </section>

      <div className="about-us-image-row">
        <img src="/images/ps1.jpg" alt="Community gathering" className="about-us-img-small" />
        <img src="/images/ps5.jpg" alt="Team members" className="about-us-img-small" />
      </div>

      <section className="about-us-section vision-section">
        <div className="vision-content">
          <div className="vision-text">
            <h2>Vision Statement</h2>
            <p>
              To glorify God by seeing adolescents choose abstinence in thriving communities and continuously preparing for successful marriages.
            </p>
          </div>
          <div className="vision-image">
            <img src="/images/ps6.jpg" alt="Abstinent Adolescents community" className="about-us-img-medium" />
          </div>
        </div>
      </section>

      <section className="about-us-section">
        <h2>Three Pillars</h2>
        <ul>
          <li>Community: It can be easy to feel like you’re walking alone on the abstinence journey. We’ve established a strong community of students committed to abstinence. We seek to provide a community for people seeking other individuals to walk alongside them in their journey.</li>
          <li>Education: Sex education in schools has often neglected abstinence as a valid choice. We want to change that by informing people about the physical, mental, and spiritual health benefits of abstaining. We do this by hosting educational events that provide information on abstinence and sex education research.</li>
          <li>Mentorship: We provide mentorship for those who need help throughout their abstinence journey. This is a 1:1 mentor/mentee system dedicated to helping people who would benefit from having someone who can provide guidance, encouragement, and direction to them. This program has yet to be established and will be starting soon!</li>
        </ul>
      </section>

      <div className="about-us-image-row">
        <img style={{ objectPosition: 'center 30%' }} src="/images/ps2.jpg" alt="Abstinent Adolescents gathering" className="about-us-img-small" />
        <img src="/images/ps8.jpg" alt="Team spirit" className="about-us-img-small" />
      </div>

      <button onClick={() => navigate('/what-we-believe')} className="about-us-button">
        Learn What We Believe
      </button>
    </div>
  );
};

export default AboutUs;
